import { loader } from 'graphql.macro';
import { graphql } from 'react-apollo';

const COMPATIBLE_APPS = loader('./CompatibleApps.graphql');

const skip = ({ vendor }) => vendor === undefined;

const options = ({ vendor }) => ({
  variables: {
    vendor,
    limit: 4
  }
});

const props = ({ data: { loading, vendor, error } }) => {
  let name = 'Vendor';
  let compatibleApps = { total: 0, apps: [] };
  if (vendor) {
    name = vendor.name;
    compatibleApps = vendor.compatibleApps;
  }
  return {
    loading,
    name,
    compatibleApps,
    error
  };
};

const withCompatibleApps = graphql(COMPATIBLE_APPS, {
  alias: 'withCompatibleApps',
  skip,
  options,
  props
});

export default withCompatibleApps;
export { skip, options, props };
